<template>
  <v-form class="d-flex justify-center flex-column">
    <v-card-text class="d-flex flex-column align-center justify-center" :class="!$vuetify.breakpoint.lgAndUp && 'px-0 mx-0'">
      <p class="text-center">{{ $t('message.accountCreationAcknowledgement') }}</p>
      <div class="my-6 d-flex flex-column align-center justify-center" :class="!$vuetify.breakpoint.smAndUp ? 'w-80' : 'w-40'">
        <p class="font-weight-bold primary--text text--darken-1 mb-2">{{ $t('label.downloadAppFrom') }}</p>
        <div></div>
        <a href="https://play.google.com/store/apps/details?id=com.oliving.app" :class="!$vuetify.breakpoint.lgAndUp ? 'w-80' : 'w-100'" target="_blank">
          <img class="app-store-badge mb-2 w-100" src="@/assets/google-play-badge.png" />
        </a>
        <a href="https://apps.apple.com/my/app/oly/id1572981807" :class="!$vuetify.breakpoint.lgAndUp ? 'w-80' : 'w-100'" target="_blank">
          <img class="app-store-badge mb-2" src="@/assets/app-store-badge.png" />
        </a>
        <a href="https://urldra.cloud.huawei.com/dbR4hINcpG" :class="!$vuetify.breakpoint.lgAndUp ? 'w-80' : 'w-100'" target="_blank">
          <img class="app-store-badge w-100" src="@/assets/huawei.png" />
        </a>
      </div>
    </v-card-text>

    <v-card-actions class="d-flex flex-column align-stretch px-4">
      <v-btn color="primary" class="mb-5 rounded-pill green-gradient-right text-capitalize override-disabled-styles" type="submit" :loading="loading" @click="login">
        {{ $t('label.login') }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      loading: false
    }
  },

  methods: {
    ...mapActions('auth', ['getProfile']),

    async login() {
      this.loading = true
      await this.getProfile().finally(() => {
        this.loading = false
        this.$emit('input', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.w-40 {
  width: 40%;
}
</style>
